module.exports = __webpack_public_path__ + "ef41425af9f3138a8946a9e73e8445c8.pdf";